// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XKxk","colBig":"styles_colBig__jD95v","colSmall":"styles_colSmall__1NxEg"};